import React, { useContext } from 'react';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import { CartContextProvider } from '../../context/CartContext/CartContext';
import ReviewPortfolioAllocation from '../ReviewPortfolioSection/ReviewPortfolioSection';
import { FlowContext } from '../../core/flow-engine';
import { RewardsContext } from '../../context/RewardsContext/RewardsContext';
import styles from './styles.css';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import { modalCloseHandler } from '../Modal/utils';

const DifferentRDFModal = () => {
  const {
    next,
    appState: {
      store: {
        loadedData: { rdfData: rdfRecommendation },
        amount
      }
    }
  } = useContext(FlowContext);

  const { rewardsAvailable = {} } = useContext(RewardsContext) || {};

  const recommendation = [
    {
      name: rdfRecommendation.name,
      ticker: rdfRecommendation.ticker,
      trpCode: rdfRecommendation.trpCode,
      amount,
      percent: 100
    }
  ];

  const modalTitle = `Review your new recommendation`;
  const modalDescription = `Here’s our new Retirement Fund Recommendation based on your date of birth.`;

  const closeRDFModal = () => {
    return next('close-rdf-modal')();
  };

  return (
    <>
      <MFBeaconModal open removeCloseButton>
        <div className="beacon-modal__title">{modalTitle}</div>
        <div className="beacon-modal__description">{modalDescription}</div>
        <span className="modal-close-icon">
          <MFBeaconIconButton
            variant="tertiary"
            id="differentRDFModalClose"
            data-name="differentRDFModalClose"
            onClick={() => {
              modalCloseHandler();
              closeRDFModal();
            }}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="modal-content">
          <CartContextProvider
            initialTotalAmount={amount}
            initialPercentMode
            initialFunds={recommendation}>
            <ReviewPortfolioAllocation
              formattedSelectedFunds={recommendation}
              small
              rewardsAvailable={rewardsAvailable}
            />
          </CartContextProvider>
        </div>
        <div className="rdf-modal-btn-container" slot="action-zone">
          <MFBeaconButton
            type="button"
            id="differentRDFModalCancel"
            data-name="differentRDFModalCancel"
            variant="tertiary"
            noButtonMargin
            onClick={() => {
              modalCloseHandler();
              closeRDFModal();
            }}
            label="Cancel"
          />
          <MFBeaconButton
            type="button"
            id="selectDifferentRDF"
            data-name="selectDifferentRDF"
            variant="primary"
            noButtonMargin
            onClick={() => {
              modalCloseHandler();
              next('modal-update')();
            }}
            label={`Select ${rdfRecommendation.ticker}`}
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default DifferentRDFModal;
